import { render, staticRenderFns } from "./SignRequestTemplate.vue?vue&type=template&id=35c9b5e6&"
import script from "./SignRequestTemplate.vue?vue&type=script&lang=js&"
export * from "./SignRequestTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SignRequestTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports